/**
 * Sticky filter + sort for Dawn collection pages (vertical filters).
 * The header is "sticky on scroll up": it hides when scrolling down and returns when
 * scrolling up. We track that state and set --sticky-top so the sort bar and filter
 * sidebar sit just below the header when it is visible, and flush to the top when hidden.
 */
(function () {
  var root = document.documentElement;

  var css = [
    /* Mobile: the "Filter and sort" bar stays pinned */
    '@media screen and (max-width: 749px){',
    '  #main-collection-filters{position:sticky;top:var(--sticky-top,0px);z-index:2;',
    '    background:rgb(var(--color-background));transition:top .25s ease;}',
    /* keep the open filter drawer above the header, as it is by default */
    '  #main-collection-filters:has(details[open]){z-index:10;}',
    '}',
    /* Desktop: sort bar pinned on top, filter sidebar pinned below it */
    '@media screen and (min-width: 750px){',
    '  .facets-vertical-sort{position:sticky;top:var(--sticky-top,0px);z-index:2;',
    '    background:rgb(var(--color-background));padding-top:.8rem;padding-bottom:.8rem;',
    '    box-shadow:0 1px 0 rgba(var(--color-foreground),.08);transition:top .25s ease;}',
    '  .facets-vertical #main-collection-filters{position:sticky;align-self:flex-start;z-index:1;',
    '    top:calc(var(--sticky-top,0px) + var(--sticky-sort-h,0px) + 1rem);',
    '    max-height:calc(100vh - var(--sticky-top,0px) - var(--sticky-sort-h,0px) - 2rem);',
    '    overflow-y:auto;scrollbar-width:thin;transition:top .25s ease;}',
    '}'
  ].join('\n');

  function injectStyle() {
    if (document.getElementById('collection-sticky-style')) return;
    var s = document.createElement('style');
    s.id = 'collection-sticky-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function update() {
    var h = document.querySelector('.section-header');
    var top = 0;
    if (h &&
        h.classList.contains('shopify-section-header-sticky') &&
        !h.classList.contains('shopify-section-header-hidden')) {
      top = h.offsetHeight;
    }
    root.style.setProperty('--sticky-top', top + 'px');

    var sort = document.querySelector('.facets-vertical-sort');
    var sortH = sort && sort.offsetParent !== null ? sort.offsetHeight : 0;
    root.style.setProperty('--sticky-sort-h', sortH + 'px');
  }

  function init() {
    injectStyle();
    update();

    var h = document.querySelector('.section-header');
    if (h) {
      new MutationObserver(update).observe(h, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
